<nav class="navbar pt-0 navbar-expand-lg navbar-default bg-default navbar-static-side" role="navigation">
  <div class="sidebar-collapse">
    <ul class="nav metismenu" id="side-menu">
      <li class="nav-header full-width">
        <ng-content></ng-content>
      </li>

      <li [class.active]="isActive(item)" shared-ui-navbars-navbar-item *ngFor="let item of items" [item]="item" [isActive]="isActive(item)" (click)="onClick(item)"></li>
    </ul>
  </div>
</nav>
